import IntegrationDisconnectionWarningBanner from './IntegrationDisconnectionWarningBanner.Container';

export default IntegrationDisconnectionWarningBanner;
